var intervalId;

// Function to debounce calls to another function
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// Check for the presence of the target element after a delay
var checkElement = () => {
  // Select the cart count span element
  var slider_Cart = $('#slidecarthq');
  if (slider_Cart.length) {
    // Select the item count div
    var itemCountDiv = $('#item_count');

    // Function to update the item count div with the cart count
    var updateItemCount = debounce(function() {
      if ($('#slidecarthq .cart-count').text().trim()) {
        itemCountDiv.text($('#slidecarthq .cart-count').text().trim());
      } else {
        itemCountDiv.text("0");
      }

      /* Updating Backorder or Quantity text */
      async function fetchData(url) {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Error fetching product data: ${response.statusText}`);
        }
        return await response.json();
      }

      (async () => {
        $('#slidecarthq .items .item').each(async function() {
          var item = $(this);  // Correct handling of `this`
          var prod_cart_href = item.find('.title > a').attr('href').split("?")[0];
          var url_prod_cart = "https://bombayhair.com/" + prod_cart_href + ".js";
          try {
            const data = await fetchData(url_prod_cart);
            data.variants.forEach(variant => {
              if(variant.id == item.data("variant-id") && ![4492776833112, 7311853027416, 7314112905304, 8446647238744].includes(data.id)){
                if(variant.inventory_quantity <= 0 && item.find('.ibat-cartbackorder').length == 0){
                  item.find('.main-top-left').append('<p class="ibat-cartbackorder">Backorder: Ships Once In Stock</p>');
                } else if(variant.inventory_quantity <= 4 && variant.inventory_quantity > 0 && item.find('.ibat-cartbackorder').length == 0){
                  item.find('.main-top-left').append('<p class="ibat-cartbackorder">Less than 4 In Stock</p>');
                }
              }
            });
          } catch (error) {
            console.error("Error:", error);
          }
        });
      })();
    }, 700);

    // Use MutationObserver to observe changes in #slidecarthq
    var observer = new MutationObserver(function(mutationsList) {
      for (var mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // Check if the mutation is not within the excluded div
          if (!$(mutation.target).closest('.main-top-left').length) {
            updateItemCount(mutation); // Call updateItemCount only if not within the excluded div
          }
        }
      }
    });

    // Start observing #slidecarthq for child node additions
    observer.observe(slider_Cart[0], {
      childList: true,
      subtree: true
    });

    updateItemCount();
    clearInterval(intervalId); // Clear the interval if element is found
  } else {
    console.log('Element not found. Checking again...');
  }
};

// Start checking after a delay of 3.5 seconds
setTimeout(() => {
  intervalId = setInterval(checkElement, 1000); // Check every 1 second
}, 3500);